import * as Effect from "effect/Effect";

export const LIVE_RUN_DIAGNOSTIC_STORAGE_KEY = "t3:diagnostics:live-run-flicker";

type DiagnosticAttributes = Readonly<Record<string, unknown>>;

let cachedEnabled: boolean | undefined;

function readLiveRunDiagnosticsEnabled(): boolean {
  try {
    const storage = Reflect.get(globalThis, "localStorage") as
      | { readonly getItem?: (key: string) => string | null }
      | undefined;
    return storage?.getItem?.(LIVE_RUN_DIAGNOSTIC_STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

export function refreshLiveRunDiagnosticsEnabled(): boolean {
  cachedEnabled = readLiveRunDiagnosticsEnabled();
  return cachedEnabled;
}

export function liveRunDiagnosticsEnabled(): boolean {
  return cachedEnabled ?? refreshLiveRunDiagnosticsEnabled();
}

export function setLiveRunDiagnosticsEnabled(enabled: boolean): boolean {
  try {
    const storage = Reflect.get(globalThis, "localStorage") as
      | {
          readonly removeItem?: (key: string) => void;
          readonly setItem?: (key: string, value: string) => void;
        }
      | undefined;
    if (enabled) storage?.setItem?.(LIVE_RUN_DIAGNOSTIC_STORAGE_KEY, "1");
    else storage?.removeItem?.(LIVE_RUN_DIAGNOSTIC_STORAGE_KEY);
  } catch {
    // The in-memory switch remains usable when browser storage is unavailable.
  }
  cachedEnabled = enabled;
  return cachedEnabled;
}

export function logLiveRunDiagnostic(
  event: string,
  attributes: () => DiagnosticAttributes,
): Effect.Effect<void> {
  if (!liveRunDiagnosticsEnabled()) return Effect.void;
  return Effect.suspend(() => Effect.logInfo(`desktop-live-run.${event}`, attributes()));
}

export function runLiveRunDiagnostic(event: string, attributes: () => DiagnosticAttributes): void {
  if (!liveRunDiagnosticsEnabled()) {
    return;
  }
  Effect.runFork(Effect.logInfo(`desktop-live-run.${event}`, attributes()));
}
